var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconLargePaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "70px",
    viewBox: "0 0 69 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Claim Icon / Paid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Claim-Icon-/-Paid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#EBFBEE",
    x: 0,
    y: 0,
    width: 69,
    height: 70,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,14 C49.5976809,14 50.9036609,15.24892 50.9949073,16.8237272 L51,17 L51,53 C51,54.5976809 49.75108,55.9036609 48.1762728,55.9949073 L48,56 L20,56 C18.4023191,56 17.0963391,54.75108 17.0050927,53.1762728 L17,53 L17,17 C17,15.4023191 18.24892,14.0963391 19.8237272,14.0050927 L20,14 L48,14 Z M39,46 L24,46 C23.4477153,46 23,46.4477153 23,47 C23,47.5522847 23.4477153,48 24,48 L24,48 L39,48 C39.5522847,48 40,47.5522847 40,47 C40,46.4477153 39.5522847,46 39,46 L39,46 Z M44,42 L24,42 C23.4477153,42 23,42.4477153 23,43 C23,43.5128358 23.3860402,43.9355072 23.8833789,43.9932723 L24,44 L44,44 C44.5522847,44 45,43.5522847 45,43 C45,42.4477153 44.5522847,42 44,42 Z M41,38 L24,38 C23.4477153,38 23,38.4477153 23,39 C23,39.5128358 23.3860402,39.9355072 23.8833789,39.9932723 L24,40 L41,40 C41.5522847,40 42,39.5522847 42,39 C42,38.4477153 41.5522847,38 41,38 Z M32,22 L24,22 C23.4477153,22 23,22.4477153 23,23 C23,23.5128358 23.3860402,23.9355072 23.8833789,23.9932723 L24,24 L32,24 C32.5522847,24 33,23.5522847 33,23 C33,22.4477153 32.5522847,22 32,22 Z",
    id: "Combined-Shape",
    fill: "#8CE99A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(38.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#69DB7C",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "round-attach_money-24px",
    transform: "translate(8.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24,6.14444444 C2.424,5.68555556 1.84,5.21111111 1.84,4.47222222 C1.84,3.62444444 2.648,3.03333333 4,3.03333333 C5.136,3.03333333 5.704,3.45333333 5.912,4.12222222 C6.008,4.43333333 6.272,4.66666667 6.608,4.66666667 L6.848,4.66666667 C7.376,4.66666667 7.752,4.16111111 7.568,3.67888889 C7.232,2.76111111 6.448,1.99888889 5.2,1.70333333 L5.2,1.16666667 C5.2,0.521111111 4.664,0 4,0 C3.336,0 2.8,0.521111111 2.8,1.16666667 L2.8,1.68 C1.248,2.00666667 0,2.98666667 0,4.48777778 C0,6.28444444 1.528,7.17888889 3.76,7.7 C5.76,8.16666667 6.16,8.85111111 6.16,9.57444444 C6.16,10.1111111 5.768,10.9666667 4,10.9666667 C2.68,10.9666667 2,10.5077778 1.736,9.85444444 C1.616,9.55111111 1.344,9.33333333 1.016,9.33333333 L0.792,9.33333333 C0.256,9.33333333 -0.12,9.86222222 0.08,10.3444444 C0.536,11.4255556 1.6,12.0633333 2.8,12.3122222 L2.8,12.8333333 C2.8,13.4788889 3.336,14 4,14 C4.664,14 5.2,13.4788889 5.2,12.8333333 L5.2,12.3277778 C6.76,12.04 8,11.1611111 8,9.56666667 C8,7.35777778 6.056,6.60333333 4.24,6.14444444 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconLargePaid);
export default __webpack_public_path__ + "static/media/claim-icon-large-paid.dd15e59ca7b6798e0e324c4123830989.svg";
export { ForwardRef as ReactComponent };